"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetStatus = void 0;
var react_1 = require("react");
var ui_components_1 = require("@l2p/ui-components");
var pay_api_1 = require("@l2p/pay-api");
var useGetStatus = function () {
    return (0, react_1.useCallback)(function (status) {
        return status === pay_api_1.TransactionStatusEnum.Accepted
            ? ui_components_1.StatusType.success
            : status === pay_api_1.TransactionStatusEnum.Declined
                ? ui_components_1.StatusType.error
                : ui_components_1.StatusType.warning;
    }, []);
};
exports.useGetStatus = useGetStatus;
